export default __webpack_public_path__ + "static/media/reeju.0b222cea.png";